export default __webpack_public_path__ + "static/media/stars-background.0058d226.png";